import { createStyles } from '@mantine/core';

type StyleParams = {
  isSidePanel?: boolean;
  isChatOpen?: boolean;
  chatOffset?: number;
};

const useStyles = createStyles(
  (theme, { isSidePanel, isChatOpen, chatOffset = 0 }: StyleParams = {}) => ({
    promoContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      padding: `0 ${theme.other.spacing._12}px`,
    },
    promoContent: {
      display: 'flex',
      justifyContent: 'flex-start',
      maxWidth: theme.other.screenWidth.lg,
      width: '100%',
      paddingTop: theme.other.spacing._24,
      paddingBottom: theme.other.spacing._12,

      '&:empty': {
        display: 'none',
      },
    },

    contentContainer: {
      padding: theme.spacing.sm,
      paddingTop: 0,
      paddingBottom: 0,
      background: isSidePanel ? theme.white : theme.colors.gray[1],
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    content: {
      width: isSidePanel ? '100%' : theme.other.screenWidth.lg,
      maxWidth: '100%',
      display: 'flex',
    },
    description: {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
    },
    main: {
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.xl * 1.5,
      flexGrow: 1,
      width: '100%',
      overflow: 'hidden',

      ...(isSidePanel
        ? {}
        : {
            [`@media (min-width: ${theme.breakpoints.md + chatOffset}px)`]: {
              paddingRight: /* eslint-disable-line local-rules/use-theme-tokens */ '32px',
              paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ '36px',
            },
          }),
    },
    locationBanner: {
      marginBottom: theme.spacing.xl,
    },
    side: {
      paddingTop: theme.spacing.xl * 1.5,
      paddingBottom: theme.spacing.xl * 1.5,
      width: isChatOpen ? 0 : 350,
      flexShrink: 0,
      borderLeft: isChatOpen ? 'none' : `1px solid ${theme.colors.gray[1]}`,
      overflow: 'hidden',
      transition:
        'width 0.3s ease-in-out, padding 0.3s ease-in-out, opacity 0.3s ease-in-out, border 0.3s ease-in-out',
      opacity: isChatOpen ? 0 : 1,
      ...(isChatOpen && {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
      }),

      ...(isSidePanel && {
        display: 'none',
      }),

      ...(!isSidePanel &&
        !isChatOpen && {
          [`@media (max-width: ${theme.breakpoints.md + chatOffset - 1}px)`]: {
            display: 'none',
          },

          [`@media (min-width: ${theme.breakpoints.md + chatOffset}px)`]: {
            paddingLeft: /* eslint-disable-line local-rules/use-theme-tokens */ '32px',
            boxSizing: 'content-box',
          },
        }),
    },
    skeletonHeader: {
      height: 330,

      ...(isSidePanel
        ? {
            height: 370,
          }
        : {
            [`@media (max-width: ${theme.breakpoints.sm + chatOffset - 1}px)`]: {
              height: 370,
            },
          }),
    },
  })
);

export default useStyles;
